import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { FeaturesConfigModule, I18nModule } from '@spartacus/core';
import { OrderConfirmationOrderEntriesContextToken } from '@spartacus/order/root';
import { CardModule, FormErrorsModule, OutletModule, PromotionsModule, PwaModule, PasswordVisibilityToggleModule, FormRequiredAsterisksComponent, FormRequiredLegendComponent, IconModule } from '@spartacus/storefront';
import { OrderConfirmationModule, OrderConfirmationOrderEntriesContext } from "@spartacus/order/components";
import { GenOrderConfirmationItemsComponent } from "./order-confirmation-items/order-confirmation-items.component";
import { GenOrderConfirmationTotalsComponent } from "./order-confirmation-totals/order-confirmation-totals.component";
import { GenShippingGroupsComponent } from 'src/app/generac/shared/components/shipping-groups/shipping-groups.component';
import { GenOrderConfirmationThankYouMessageComponent } from './order-confirmation-thank-you-message/order-confirmation-thank-you-message.component';
import { AbstractOrderContextModule } from '@spartacus/cart/base/components';
import { GenCartSharedModule } from '../../cart/cart-shared/cart-shared.module';
import { GenOrderSummaryComponent } from '../../../shared/components/order-summary/order-summary.component';
import { GenOrderOverviewModule } from '../order-details/order-overview/order-overview.module';

@NgModule({
  imports: [
    CommonModule,
    CardModule,
    PwaModule,
    PromotionsModule,
    I18nModule,
    ReactiveFormsModule,
    FormErrorsModule,
    GenOrderOverviewModule,
    OutletModule,
    IconModule,
    PasswordVisibilityToggleModule,
    GenOrderSummaryComponent,
    GenShippingGroupsComponent,
    OutletModule.forChild(),
    AbstractOrderContextModule,
    FeaturesConfigModule,
    FormRequiredAsterisksComponent,
    FormRequiredLegendComponent,
    OrderConfirmationModule,
    GenCartSharedModule,
  ],
  providers: [
    {
      provide: OrderConfirmationOrderEntriesContextToken,
      useExisting: OrderConfirmationOrderEntriesContext,
    },
  ],
  declarations: [
    GenOrderConfirmationItemsComponent,
    GenOrderConfirmationTotalsComponent,
    GenOrderConfirmationThankYouMessageComponent,
  ],
  exports: [
    GenOrderConfirmationItemsComponent,
    GenOrderConfirmationTotalsComponent,
    GenOrderConfirmationThankYouMessageComponent,
  ],
})
export class GenOrderConfirmationModule { }
